import { IconChevronRightSmall } from '@components/icons/chevron-right-small';
import { IconCompany } from '@components/icons/company';
import { Menu } from '@components/menu';
import { Nav } from '@components/nav';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

import { useCurrentUser, useSwitchCompany } from 'api/authentication/hooks';

export const CompanySelector = () => {
  const { t } = useScopedTranslate(locale);
  const user = useCurrentUser();
  const switchCompanyMutation = useSwitchCompany();
  const companies = user?.companies ?? [];
  const currentCompany = user?.company;
  if (companies.length < 2 || !currentCompany) {
    return null;
  }

  return (
    <Nav.Menu
      icon={<IconCompany size={16} />}
      iconRight={<IconChevronRightSmall />}
      label={currentCompany.name}
    >
      <Menu.Label label={t('companies')} icon={<IconCompany />} />
      <Nav.Separator margin={`${pxToRem(8)} 0`} />
      {companies.map((company) => (
        <Nav.MenuItem
          isActive={company.id === currentCompany.id}
          key={company.id}
          onSelect={
            company.id !== currentCompany.id
              ? () => switchCompanyMutation.mutate(company)
              : () => null
          }
          label={company.name}
        />
      ))}
    </Nav.Menu>
  );
};

const locale = {
  en: {
    companies: 'COMPANIES',
    test: 'Test',
  },
};
